interface Props {
  name: string;
  email: string;
}

/**
 * Tarjeta con la info del candidato. Como la identificación ya viene del UUID
 * del link, solo muestra los datos (no hay form).
 */
export function CandidateCard({ name, email }: Props) {
  return (
    <div className="rounded-[var(--radius)] border border-success/30 bg-success/[0.04] px-5 py-4">
      <div className="text-success font-semibold text-base">{name}</div>
      <div className="text-muted-foreground text-sm mt-0.5">{email}</div>
    </div>
  );
}
